import { render } from "./Calendar.vue?vue&type=template&id=aa3ac240"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "aa3ac240"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aa3ac240', script)) {
    api.reload('aa3ac240', script)
  }
  
  module.hot.accept("./Calendar.vue?vue&type=template&id=aa3ac240", () => {
    api.rerender('aa3ac240', render)
  })

}

script.__file = "src/icons/components/filled/Calendar.vue"

export default script